<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.25 0C11.2165 0 12 0.783502 12 1.75L12 7.58594C12 8.05001 11.8155 8.49509 11.4873 8.82324L8.82324 11.4873C8.49509 11.8155 8.05001 12 7.58594 12L1.75 12C0.783502 12 0 11.2165 0 10.25L0 1.75C0 0.783502 0.783502 0 1.75 0L10.25 0ZM3 8.25C2.58579 8.25 2.25 8.58579 2.25 9C2.25 9.41421 2.58579 9.75 3 9.75H5C5.41421 9.75 5.75 9.41421 5.75 9C5.75 8.58579 5.41421 8.25 5 8.25H3ZM3 5.25C2.58579 5.25 2.25 5.58579 2.25 6C2.25 6.41421 2.58579 6.75 3 6.75H8C8.41421 6.75 8.75 6.41421 8.75 6C8.75 5.58579 8.41421 5.25 8 5.25H3ZM3 2.25C2.58579 2.25 2.25 2.58579 2.25 3C2.25 3.41421 2.58579 3.75 3 3.75L9 3.75C9.41421 3.75 9.75 3.41421 9.75 3C9.75 2.58579 9.41421 2.25 9 2.25L3 2.25Z"
      fill="#3769D6"
    />
  </svg>
</template>
